import { useQuery } from "@tanstack/react-query";
import { getStatsProjets } from "../../api/STATISTIQUES/statistiques";

export const useStatsProjets = (filters = {}) => {
  return useQuery({
    queryKey: ["statsProjets", filters],
    queryFn: () => getStatsProjets(filters),
    staleTime: 5 * 60 * 1000,
  });
};
